<script setup lang="ts">
import Navigation from '@/components/Navigation.vue'
const { $setMaxWidth, $setSize } = useNuxtApp()

const props = defineProps({
    project: {
        type: Object,
        required: true
    }
})

const projectColor = computed(() => {
    return props.project.themeColor || '#fff'
})

const projectLink = computed(() => {
    if (props.project.returnUrl && props.project.returnUrl.length > 0) {
        return props.project.returnUrl
    } else {
        return `/${props.project.slug}`
    }
})

onMounted(() => {
    document.documentElement.style.setProperty('--project-color', projectColor.value)
    $setSize()
})
</script>
<template>
    <div class="header-component">
        <Navigation
            :projectName="project.name"
            :projectLink="projectLink"
            :projectLogo="project.logo ? `${project.assetRoot}/${project.logo}` : null"
            :projectColor="projectColor"
            :projectSlug="project.slug"
        />
    </div>
</template>
